@file:OptIn(InternalResourceApi::class)

package com.bikompanion.ui

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.bikompanion.ui/"

@delegate:ResourceContentHash(-742_272_340)
public val Res.font.noto_sans_arabic: FontResource by lazy {
      FontResource("font:noto_sans_arabic", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_arabic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(953_587_378)
public val Res.font.noto_sans_jp: FontResource by lazy {
      FontResource("font:noto_sans_jp", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_jp.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_640_001_590)
public val Res.font.noto_sans_kr: FontResource by lazy {
      FontResource("font:noto_sans_kr", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_kr.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_047_127_201)
public val Res.font.noto_sans_sc: FontResource by lazy {
      FontResource("font:noto_sans_sc", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_sc.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(713_016_334)
public val Res.font.roboto_flex: FontResource by lazy {
      FontResource("font:roboto_flex", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_flex.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("noto_sans_arabic", Res.font.noto_sans_arabic)
  map.put("noto_sans_jp", Res.font.noto_sans_jp)
  map.put("noto_sans_kr", Res.font.noto_sans_kr)
  map.put("noto_sans_sc", Res.font.noto_sans_sc)
  map.put("roboto_flex", Res.font.roboto_flex)
}
